(function () {
  const STORAGE_KEY = 'theme:wishlist';
  const EVENT_NAME = 'wishlist:changed';

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function emit() {
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { items: read() } }));
  }

  const Wishlist = {
    all() {
      return read();
    },
    handles() {
      return read().map(function (item) { return item.handle; }).filter(Boolean);
    },
    ids() {
      return read().map(function (item) { return String(item.id); });
    },
    has(id) {
      const sid = String(id);
      return read().some(function (item) { return String(item.id) === sid; });
    },
    add(id, handle) {
      if (!id || !handle) return false;
      const list = read();
      if (list.some(function (i) { return String(i.id) === String(id); })) return false;
      list.unshift({ id: String(id), handle: handle, addedAt: Date.now() });
      write(list);
      emit();
      return true;
    },
    remove(id) {
      const sid = String(id);
      const list = read().filter(function (item) { return String(item.id) !== sid; });
      write(list);
      emit();
    },
    toggle(id, handle) {
      if (this.has(id)) {
        this.remove(id);
        return false;
      }
      this.add(id, handle);
      return true;
    },
    clear() {
      write([]);
      emit();
    },
    count() {
      return read().length;
    },
    on(handler) {
      document.addEventListener(EVENT_NAME, handler);
    },
    off(handler) {
      document.removeEventListener(EVENT_NAME, handler);
    }
  };

  window.Wishlist = Wishlist;

  function syncButton(btn) {
    const id = btn.getAttribute('data-product-id');
    const active = Wishlist.has(id);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    const labelOn = btn.getAttribute('data-label-on');
    const labelOff = btn.getAttribute('data-label-off');
    if (labelOn && labelOff) {
      btn.setAttribute('aria-label', active ? labelOn : labelOff);
    }
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(syncButton);
  }

  function syncHeader() {
    const has = Wishlist.count() > 0;
    document.querySelectorAll('[data-wishlist-indicator]').forEach(function (el) {
      el.classList.toggle('is-active', has);
    });
  }

  function bindButton(btn) {
    if (btn.dataset.wishlistBound === '1') return;
    btn.dataset.wishlistBound = '1';
    syncButton(btn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const id = btn.getAttribute('data-product-id');
      const handle = btn.getAttribute('data-product-handle');
      Wishlist.toggle(id, handle);
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-wishlist-button]').forEach(bindButton);
  }

  function onChange() {
    syncAllButtons();
    syncHeader();
  }

  function init() {
    bindAll();
    syncHeader();
    Wishlist.on(onChange);

    const observer = new MutationObserver(function (mutations) {
      let added = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-wishlist-button]')) {
            bindButton(node);
            added = true;
          } else if (node.querySelectorAll) {
            node.querySelectorAll('[data-wishlist-button]').forEach(function (b) {
              bindButton(b);
              added = true;
            });
          }
        });
      });
      if (added) syncHeader();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) emit();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
